import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=900dd20e&scoped=true"
import script from "./SingleSelect.vue?vue&type=script&lang=ts"
export * from "./SingleSelect.vue?vue&type=script&lang=ts"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=900dd20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900dd20e",
  null
  
)

export default component.exports